// extracted by mini-css-extract-plugin
module.exports = {"main-map__body":"style_main-map__body__BXQzF"};